export enum CsvCompatibility {
  GoogleSpreadsheet = 'GOOGLE_SPREADSHEET',
  Excel = 'EXCEL',
}
